/** Duration limits for authored envelopes and their timed procedures, excluding consultations. */
export const ENVELOPE_DURATION_CAP_MINUTES = 480;
export const ENVELOPE_DURATION_INCREMENT_MINUTES = 5;
